import React, { useState, useEffect, useRef, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { DataGridPro, GridToolbarContainer, GridToolbarExport, GridToolbarQuickFilter, useGridApiRef, gridFilteredSortedRowIdsSelector, GRID_CHECKBOX_SELECTION_COL_DEF, gridFilterableColumnLookupSelector, GridFooter } from '@mui/x-data-grid-pro';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Navbar from 'react-bootstrap/Navbar';
import Button from 'react-bootstrap/Button';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { FaChevronDown } from 'react-icons/fa';
import { formatPhone } from '../../common/utils';
import { ToastContainer } from 'react-toastify';
import AddToGroup from '../../components/Modals/AddToGroup';
import AddEvent from '../../components/Modals/AddEvent';
import SendMassTxt from '../../components/Modals/SendMassTxt';
import SendMassEmail from '../../components/Modals/SendMassEmail';
import { ModalCtx } from '../../contexts';
import CompactView from '../../components/Event/CompactView';
import Details from '../../components/Event/Details';

import "react-toastify/dist/ReactToastify.css";


const Event = ( { aid, uid, canExport, events, contacts, layoutHeader, layoutDetails } ) => {
    let params = useParams();
    const [ loadingMembers, setLoadingMembers ] = useState( true );
    const [ draftValues, setDraftValues ] = useState( {} );
    const [ showSave, setShowSave ] = useState( false );
    const [ gridHeight, setGridHeight ] = useState( 0 );
    const [ e, setEvent ] = useState( { 
        details: {},
        members: []
    } );
    const [show, setShow] = useState(false);
    const closeModal = () => setShow(false);
    const openModal = () => setShow(true);
    const [ modal, setModal ] = useState();
    
    const containerRef = useRef();
    const titleRef = useRef();
    
    useEffect( () => {
        // console.log( draftValues );
        let hasOrig = false;
        let cleanDraft = {};

        Object.keys( draftValues ).forEach( d => {
            if ( draftValues[d] === e.details[d] ) {
                hasOrig = true;
            } else {
                cleanDraft[d] = draftValues[d];
            }
        } );

        if ( hasOrig ) {
            setDraftValues( { ...cleanDraft } );
        }

        setShowSave( Object.keys( cleanDraft ).length );
    }, [ draftValues, e ] );

    // useEffect( () => {
    //     load( { aid: aid, uid: uid, eid: params.eid } );
    //     loadMembers( { aid: aid, uid: uid, eid: params.eid } ).then( setLoadingMembers( false ) );
    // }, [ aid, uid, params.eid, load, loadMembers ] );

    useEffect( () => {
        const list = [];
        if ( events[params.eid]?.members?.length ) {
            events[params.eid].members.forEach( m => {
                if ( contacts[m.cid] ) {
                    list.push( { 
                        ...contacts[m.cid], 
                        ...m 
                    } );
                }
            } );
        }
        if ( events ) {
            setEvent( prev => {
                return {
                    ...prev,
                    details: events[params.eid],
                    members: list
                }
            } );
        }
        setLoadingMembers( false );
    }, [ params.eid, events, contacts ] );

    useEffect( () => {
        setGridHeight( containerRef.current.clientHeight - titleRef.current.clientHeight - 15 );
    }, [ containerRef?.current?.clientHeight, titleRef?.current?.clientHeight ] );

    // useEffect( () => {
    //     console.log( 'members:', e.members );
    // }, [ e ] );

    useEffect( () => {
        document.title = `Third Floor - ${e?.details?.name}`;
    }, [ e ] );

    const handleSave = () => {

    }

    const handleCancel = () => {

    }

    const gridRef = useGridApiRef();

    const toolbar = () => {
        return(
            <GridToolbarContainer>
                <Container fluid className='p-0'>
                    <Row className='p-0 align-items-center'>
                        <Col>
                            <Row className='text-start align-items-center'>
                                <Col xs='auto' className='pe-0'>
                                    <GridFooter className='tf-fake-footer' />
                                </Col>
                                <Col>
                                    { 
                                        selectedRows.length > 0 &&
                                        <Row style={ { borderLeft: '1px solid #CCC' } }>
                                            <Col xs='auto' className='pe-2'>Take Action...</Col>
                                            <Col xs='auto' className='ps-0'>
                                                <DropdownButton size='sm' title={<FaChevronDown />} className='tf-button-transparent tf-hide-arrow'>
                                                    <Dropdown.Item onClick={ () => handleAction( 'invited' ) }>Mark as Invited</Dropdown.Item>
                                                    <Dropdown.Item onClick={ () => handleAction( 'rsvp-yes' ) }>Mark as a Yes</Dropdown.Item>
                                                    <Dropdown.Item onClick={ () => handleAction( 'rsvp-no' ) }>Mark as a No</Dropdown.Item>
                                                    <Dropdown.Item onClick={ () => handleAction( 'rsvp-maybe' ) }>Mark as a Maybe</Dropdown.Item>
                                                    <Dropdown.Item onClick={ () => handleAction( 'attended' ) }>Mark as Attended</Dropdown.Item>
                                                    <Dropdown.Divider />
                                                    <Dropdown.Item onClick={ () => handleModal( 'email-mass' ) }>Send Mass Email</Dropdown.Item>
                                                    <Dropdown.Item onClick={ () => handleModal( 'sms-mass' ) }>Send Mass Txt</Dropdown.Item>
                                                    <Dropdown.Divider />
                                                    <Dropdown.Item onClick={ () => handleModal( 'list' ) }>Add to a List</Dropdown.Item>
                                                    <Dropdown.Item onClick={ () => handleModal( 'event' ) }>Add to Another Event</Dropdown.Item>
                                                    <Dropdown.Divider />
                                                    <Dropdown.Item onClick={ () => handleModal( 'delete' ) }>Remove from this Event</Dropdown.Item>
                                                </DropdownButton>
                                            </Col>
                                        </Row>
                                    }
                                </Col>
                            </Row>
                        </Col>
                        <Col xs='auto' className='text-right'>
                            <GridToolbarQuickFilter />
                        </Col>
                        {
                            ( canExport ) ? (
                                <Col xs='auto' className='pe-3 text-right'>
                                    <GridToolbarExport />
                                </Col>
                            ) : (
                                null
                            )
                        }
                    </Row>
                </Container>
            </GridToolbarContainer>
        )
    }

    const cols = [
        { field: 'name', headerName: 'Contact', width: 175, renderCell: ( { row } ) => (
          <Link to={`/contact/${row.cid}`}>{row.firstname} {row.lastname}</Link>
        ) },
        { field: 'invitedDate', headerName: 'Invited Date', type: 'date', width: 125, valueGetter: ( { value } ) => value && new Date( value ).toLocaleDateString() },
        { field: 'rsvpYesDate', headerName: 'RSVP - Yes', type: 'date', width: 125, valueGetter: ( { value } ) => value && new Date( value ).toLocaleDateString() },
        { field: 'rsvpNoDate', headerName: 'RSVP - No', type: 'date', width: 125, valueGetter: ( { value } ) => value && new Date( value ).toLocaleDateString() },
        { field: 'rsvpMaybeDate', headerName: 'RSVP - Maybe', type: 'date', width: 125, valueGetter: ( { value } ) => value && new Date( value ).toLocaleDateString() },
        { field: 'attended', headerName: 'Attended', type: 'boolean', width: 100 },
        { field: 'phone', headerName: 'Phone', width: 125, renderCell: ( { value } ) => (
          <a href={`tel:${value}`}>{formatPhone( value )}</a>
        ) },
        { field: 'phoneMobile', headerName: 'Mobile Phone', width: 125, renderCell: ( { value } ) => (
          <a href={`tel:${value}`}>{formatPhone( value )}</a>
        ) },
        { field: 'phoneHome', headerName: 'Home Phone', width: 125, renderCell: ( { value } ) => (
          <a href={`tel:${value}`}>{formatPhone( value )}</a>
        ) },
        { field: 'email', headerName: 'Email', width: 250, renderCell: ( { value } ) => (
          <a href={`mailto:${value}`}>{value}</a>
        ) },
        { field: 'street', headerName: 'Street', width: 175 },
        { field: 'city', headerName: 'City', width: 125 },
        { field: 'state', headerName: 'State', width: 100 },
        { field: 'zip', headerName: 'Zip', width: 100 },
        { field: 'createdDate', headerName: 'Added to Event', type: 'date', width: 125, valueGetter: ( { value } ) => value && new Date( value ).toLocaleDateString() },
        { field: 'ownerId', headerName: 'Owner ID', width: 125 }
    ];
    
    const visibleCols = {
      description: false,
      ownerId: false
    };
  
    const [ selectedRows, setSelectedRows ] = useState( [] );
    
    const handleAction = ( t ) => {
        switch ( t ) {
            case 'invited':
                break;

            default:
                console.log( 'Unknown action type: ' + t );
        }
    };

    const handleModal = ( t ) => {
        let shouldOpen = true;

        let cids = [];
        let list = [];
        selectedRows.forEach( r => {
            const [ eid, cid ] = r.split( '#' );
            const c = contacts[cid];
            if ( c ) {
                cids.push( cid );
                list.push( c );
            }
        } );
                
        switch ( t ) {
            case 'email-mass':
                setModal( <SendMassEmail close={closeModal} clist={cids} objType='contact' /> );
                break;

            case 'sms-mass':
                setModal( <SendMassTxt close={closeModal} clist={cids} objType='contact' /> );
                break;    

            case 'list':
                setModal( <AddToGroup close={closeModal} contacts={contacts} /> );
                break;
    
            case 'event':
                setModal( <AddEvent close={closeModal} /> );
                break;

            default:
                shouldOpen = false;
                console.log( 'Unknown modal type: ' + t );
        }

        if ( shouldOpen ) {
            openModal();
        }
    }
    
    return (
        <Container fluid className='p-0' style={ { height: '100%' } }>
            <ModalCtx.Provider value={ { setDraftValues, openModal, closeModal, setModal } }>
                <Row style={ { height: 'calc(100vh - 125px)' } } ref={containerRef}>
                    <Col>
                        <Row className='tf-page-container' ref={titleRef}>
                            <Col className='p-0'>
                                <CompactView e={e.details} layout={layoutHeader} />
                            </Col>
                        </Row>
                        <Row style={ { height: '100%' } }>
                            <Col className='pe-0' md={6}>
                                <Row className='tf-section-container mt-0 me-2 p-0'>
                                    <Col className='p-0'>
                                        <Details e={e.details} layout={layoutDetails} />
                                    </Col>
                                </Row>
                            </Col>
                            <Col className='ps-0' md={6}>
                                <Row className='tf-section-container mt-0 ms-0 me-2 p-0'>
                                    <Col className='p-0' style={ { display: 'flex', height: `${gridHeight}px`, width: '100%' } }>
                                        <DataGridPro
                                            apiRef={gridRef}
                                            getRowId={ ( row ) => row.eilid }
                                            initialState={ { 
                                                columns: { columnVisibilityModel: visibleCols },
                                                pinnedColumns: { left: [ GRID_CHECKBOX_SELECTION_COL_DEF.field, 'name' ] }
                                            } }
                                            loading={ loadingMembers }
                                            rows={e.members}
                                            columns={cols}
                                            density='compact'
                                            checkboxSelection
                                            disableSelectionOnClick
                                            slots={ { toolbar: toolbar } }
                                            onRowSelectionModelChange={ ( ids ) => setSelectedRows( ids ) }
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </ModalCtx.Provider>
            <Modal open={show} onClose={closeModal}>
                <Fragment>
                    {modal}
                </Fragment>
            </Modal>
            <ToastContainer autoClose={3000} />
            {
                showSave ? (
                    <Navbar fixed='bottom'>
                        <Container fluid className='m-0 p-0'>
                            <Row className='tf-save-footer-container w-100 align-items-center justify-content-md-center'>
                                <Col xs='auto'><Button size='sm' variant='primary' onClick={handleSave}>Save</Button></Col>
                                <Col xs='auto'><Button size='sm' variant='outline-light' onClick={handleCancel}>Cancel</Button></Col>
                            </Row>
                        </Container>
                    </Navbar>
                ) : (
                    <Fragment />
                )
            }
        </Container>
    )
}

const mapProps = ( state ) =>( {
    aid: state.user.aid,
    uid: state.user.email,
    canExport: state.user.canExport,
    // e: state.events.current
    events: state.events.byId,
    contacts: state.contacts.byId,
    layoutHeader: state.user.meta.event.cv,
    layoutDetails: state.user.meta.event.details
} );

const mapDispatch = ( dispatch ) => ( {
    // load: dispatch.events.loadEvent,
    // loadMembers: dispatch.events.loadEventMembers
} );

export default connect( mapProps, mapDispatch )( Event );